import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';
import { ThreeThreeVC } from './ThreeThreeVC';
import { SixHC } from './SixHC';

interface SixSixArticleListComponentThemeProps {
  baseUnit: BaseUnit;
}

const isNewChunk = (index: number, chunkSize: number) => index % chunkSize === 0;

export const getArticlesInChunks = (articles: any[], chunkSize: number) => {
  let currentChunk: CardComponentDataProps[] = [];
  return articles.reduce((chunks: CardComponentDataProps[][], item, index) => {
    if (isNewChunk(index, chunkSize)) {
      currentChunk = [item];
      chunks.push(currentChunk);
    } else {
      currentChunk.push(item);
    }
    return chunks;
  }, []);
};

const getSixSixArticleListStyle = (baseUnit: BaseUnit) => {
  return StyleSheet.create({
    verticalCardsGrid: {
      marginBottom: `${baseUnit}px`,
    },
    horizontalCardsGrid: {
      marginBottom: `${baseUnit / 2}px`,
      marginTop: `${baseUnit / 2}px`,
    },
  });
};

type SectionsOrder = 'vertical-horizontal' | 'horizontal-vertical';

interface SixSixArticleListProps {
  cardsProps: CardComponentDataProps[];
  order?: SectionsOrder;
}

export const SixSixArticleList: React.FunctionComponent<SixSixArticleListProps> = ({ cardsProps, order = 'vertical-horizontal' }) => {
  const { baseUnit } = useTheme<SixSixArticleListComponentThemeProps>();
  const SixSixArticleListStyle = getSixSixArticleListStyle(baseUnit);
  const firstSectionStyle = order === 'vertical-horizontal' ? SixSixArticleListStyle.verticalCardsGrid : SixSixArticleListStyle.horizontalCardsGrid;
  const secondSectionStyle = order === 'vertical-horizontal' ? SixSixArticleListStyle.horizontalCardsGrid : SixSixArticleListStyle.verticalCardsGrid;
  const FirstSectionCard = order === 'vertical-horizontal' ? ThreeThreeVC : SixHC;
  const SecondSectionCard = order === 'vertical-horizontal' ? SixHC : ThreeThreeVC;
  const createGrids = (cards: CardComponentDataProps[], index: number) => {
    return (index % 2 === 0
      ? (
        <div className={css(firstSectionStyle)} key={index}>
          <FirstSectionCard cards={cards} />
        </div>
      )
      : (
        <div className={css(secondSectionStyle)} key={index}>
          <SecondSectionCard cards={cards} />
        </div>
      )
    );
  };
  return (
    <ErrorBoundary>
      {getArticlesInChunks(cardsProps, 6).map(createGrids)}
    </ErrorBoundary>
  );
};
